interface ApiErrorDetail {
  loc: string[];
  msg: string;
  type: string;
}

export function mapApiErrors(
  detail: ApiErrorDetail[] | string | undefined,
): Record<string, string> {
  if (!Array.isArray(detail)) return {};

  const errors: Record<string, string> = {};

  for (const item of detail) {
    const fieldPath = item.loc.slice(2).join('.');
    if (fieldPath) {
      errors[fieldPath] = item.msg;
    }
  }

  return errors;
}
